import { RoutePaths } from "../RoutePaths";
import { NavigateFunction } from "react-router-dom";

export function writeCurrentLocationToLocalStorage() {
  const urlWithoutOriginB4Redirect = window.location.href.replace(
    window.location.origin,
    "",
  );
  console.debug(
    "LocationRestorerAfterLogin: Putting current location to local storage to redirect the user after a successful login.",
    urlWithoutOriginB4Redirect,
  );
  localStorage.setItem("locationBeforeLogin", urlWithoutOriginB4Redirect);
}

export function navigateToLocationBeforeLogin(
  fallbackRoute: string,
  navigate: NavigateFunction,
) {
  const localStorageValue = localStorage.getItem("locationBeforeLogin");
  if (localStorageValue && isUrlAllowed(localStorageValue)) {
    console.debug(
      "LocationRestorerAfterLogin: Restoring the URL which was set before user was redirected to login.",
      localStorageValue,
    );
    localStorage.removeItem("locationBeforeLogin");
    navigate(localStorageValue, { replace: true });
  } else if (fallbackRoute) {
    console.debug("Restoring to provided fallback route.", fallbackRoute);
    navigate(fallbackRoute, { replace: true });
  } else {
    console.debug("Restoring to root because no fallback route was given.");
    navigate(fallbackRoute, { replace: true });
  }
}

function isUrlAllowed(urlToRestore: string) {
  const NOT_ALLOWED_LIST_FOR_RESTORE: readonly string[] = [
    RoutePaths.CALLBACK,
    RoutePaths.LOGOUT,
    RoutePaths.STUB_LOGIN,
  ];
  const result = NOT_ALLOWED_LIST_FOR_RESTORE.every(
    (e) => !urlToRestore.includes(e),
  );
  if (!result)
    console.warn("urlToRestore is not allowed to be restored", urlToRestore);
  return result;
}
